module.exports = __webpack_public_path__ + "static/img/nowactivating.df02f78.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/template/nowactivating.svg
// module id = 0eWE
// module chunks = 3